import { createDefaultTyrann } from '@apis/common';
import {
  warehouseHoliday,
  warehouseHolidayBase,
  warehouseHolidayQueryParams,
} from '@models/WarehouseHoliday';
import * as t from 'io-ts';

export const warehouseHolidayApis = createDefaultTyrann({
  '/dashboard/warehouse-holiday/': {
    get: {
      query: warehouseHolidayQueryParams,
      response: {
        200: t.array(warehouseHoliday),
      },
    },
    post: {
      body: warehouseHolidayBase,
      response: {
        201: warehouseHoliday,
      },
    },
  },
  '/dashboard/warehouse-holiday/{id}': {
    delete: {
      path: t.type({ id: t.number }),
      response: {
        204: t.literal(''),
      },
    },
  },
});
